import { Box, useTheme } from "@mui/system";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { IShoppingBagData } from "types/ShoppingBag";
import { Colors } from "helpers/Consts";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SingleOrderDetailsForDialog from "./singleOrderDetailsForDialog";

type IOrderDetailsProps = {
    open: boolean;
    handleClose: () => void;
    order: IShoppingBagData;
};

const OrderDetailsDialog = ({ order, handleClose, open }: IOrderDetailsProps) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            maxWidth={"lg"}
        >
            <DialogTitle>
                <Box display="flex" alignItems="center">
                    <Box>
                        <IconButton color="primary" onClick={handleClose}>
                            <ArrowBackIosIcon fill={Colors.orangePrimary} />
                        </IconButton>
                    </Box>
                    <Box
                        flexGrow={1}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography color="primary">
                            Detalhes do Pedido
                        </Typography>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: { md: "600px" },
                        height: "100%",
                    }}
                >
                    <SingleOrderDetailsForDialog order={order} />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default OrderDetailsDialog;
